import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function usePostfix(_ref) {
  var postfix = _ref.postfix,
    disabled = _ref.disabled;
  return useMemo(function () {
    return {
      id: 'postfix',
      active: false,
      show: Boolean(postfix),
      render: function render(props) {
        return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
          className: styles.postfix,
          "data-test-id": "field-postfix",
          "data-disabled": disabled || undefined,
          children: postfix
        }));
      }
    };
  }, [disabled, postfix]);
}